﻿import { DataGrid, GridPersistanceFlags, PersistedGridSettings, SummaryType } from "@serenity-is/corelib";
import { tryFirst, toId } from "@serenity-is/corelib/q";
import { Aggregators } from "@serenity-is/corelib/slick";
import { Column } from "@serenity-is/sleekgrid";

declare module "@serenity-is/sleekgrid" {
    interface Column<TItem = any> {
        summaryType?: import("@serenity-is/corelib").SummaryType;
    }
}

export interface CustomSummaryMixinOptions {
    grid: DataGrid<any, any>;
}

function toAggregator(summaryType: SummaryType): any {
    switch (summaryType) {
        case SummaryType.Sum: return Aggregators.Sum;
        case SummaryType.Avg: return Aggregators.Avg;
        case SummaryType.Max: return Aggregators.Max;
        case SummaryType.Min: return Aggregators.Min;
    }

    return null;
}

export class CustomSummaryMixin {

    constructor(options: CustomSummaryMixinOptions) {
        var dg = options.grid;

        var getDefaultAggregators = () => {
            var columns = dg['allColumns'];
            var aggregators: any[] = [];
            for (var x of columns) {

                if (x.sourceItem == null)
                    continue;

                if (x.sourceItem.summaryType != null &&
                    x.sourceItem.summaryType != SummaryType.Disabled) {

                    var aggregator = toAggregator(x.sourceItem.summaryType);
                    if (aggregator == null)
                        continue;

                    x.summaryType = x.sourceItem.summaryType;
                    aggregators.push(new aggregator(x.field));
                }
            }

            return aggregators;
        };


        dg.view.setSummaryOptions({
            aggregators: getDefaultAggregators()
        });

        var aggregatesPopup = $(`<ul class="s-AggregatesPopup" 
                style="display:none;position:absolute;z-index:100000;">
                <li data-agg="1">Sum</li>
                <li data-agg="2">Average</li>
                <li data-agg="3">Min</li>
                <li data-agg="4">Max</li>
            </ul>`).appendTo(document.body)
            .click(e => {
                if (!$(e.target).is("li"))
                    return;

                var col = aggregatesPopup.data("column") as Column;
                if (col == null || !col.id)
                    return;

                var column = tryFirst(dg['allColumns'] as Column[], x => x.id == col.id);
                if (!column)
                    return;

                if (column.sourceItem == null ||
                    column.sourceItem.summaryType == null ||
                    column.sourceItem.summaryType == SummaryType.Disabled)
                    return;

                var agg = toId($(e.target).data('agg'));
                if (agg === column.summaryType)
                    return;

                column.summaryType = agg;

                var aggregators = dg['allColumns']
                    .filter(x => x.summaryType)
                    .map(x => {
                        var aggregator = toAggregator(x.summaryType)
                        if (aggregator == null)
                            return null;

                        return new aggregator(x.field);
                    }).filter(x => x != null);

                dg.view.setSummaryOptions({
                    aggregators: aggregators
                });

                var grouping = (dg.view as any).getGrouping();
                for (var i = 0; i < grouping.length; i++)
                    grouping[i].aggregators = aggregators;

                dg.view.setGrouping(grouping);
                dg.slickGrid.invalidate();
            });

        dg.element.on('click', '.slick-footerrow-column', e => {
            e.preventDefault();

            var col = $(e.currentTarget).data('column');
            if (!col || !col.id)
                return;

            var column = tryFirst(dg['allColumns'] as Column[], x => x.id == col.id);
            if (!column)
                return;

            if (!column ||
                !column.sourceItem ||
                column.sourceItem.summaryType == null ||
                column.sourceItem.summaryType == SummaryType.Disabled)
                return;

            aggregatesPopup.data('column', column)
                .show()
                .css('top', (e.pageY - aggregatesPopup.height()) + 'px')
                .css('left', e.pageX + 'px')
                .children('li')
                .removeClass('active')
                .end()
                .children('li[data-agg=' + column.summaryType + ']')
                .addClass('active');

            $(document.body).off('click.aggregatesMenu' + dg['uniqueName']);

            window.setTimeout(() => $(document.body)
                .on("click.aggregatesMenu" + dg['uniqueName'], () => {
                    aggregatesPopup.hide();
                    $(document.body).off('click.aggregatesMenu' + dg['uniqueName']);
                }), 1);
        });

        var oldCurrentSettings = (dg as any).getCurrentSettings;
        (dg as any).getCurrentSettings = function (flags: GridPersistanceFlags) {
            var settings = oldCurrentSettings.apply(dg, [flags]);
            return settings;
        };

        var oldRestoreSettings = (dg as any).restoreSettings;
        (dg as any).restoreSettings = function (settings?: PersistedGridSettings,
            flags?: GridPersistanceFlags) {
            oldRestoreSettings.apply(dg, [settings, flags]);
        };
    }
}